import { render, staticRenderFns } from "./CChartPurchasesPerMonth.vue?vue&type=template&id=8d858352"
import script from "./CChartPurchasesPerMonth.vue?vue&type=script&lang=js"
export * from "./CChartPurchasesPerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports